import type { SiteCopy } from '../i18n';

/** Russian site-wide copy. Name stays "StudyLabPro". */
export const siteRu: Partial<SiteCopy> = {
  title: 'StudyLabPro — независимая AI-first R&D-лаборатория',
  tagline: 'Независимая AI-first R&D-лаборатория',
  description:
    'StudyLabPro — живая лаборатория искусственного интеллекта: агент-native среды, графы знаний, адаптивная платформа обучения StudyNinja и численные основания — исследования, которые доходят до продакшена.',
};
